import { useEffect, useRef, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

const getVisitId = () => {
  let v = sessionStorage.getItem("cml_visit_id");
  if (!v) {
    v = "visit_" + Math.random().toString(36).slice(2, 10) + "_" + Date.now();
    sessionStorage.setItem("cml_visit_id", v);
  }
  return v;
};

// Tracks a single visit: active (visible) seconds, chat activity and drop-off signals.
export function useVisitTracking(userMessageCount = 0, signals = {}) {
  const { privacyAccepted = false, typed = false } = signals;
  const [visitId] = useState(getVisitId);
  const activeRef = useRef(0);
  const stateRef = useRef({ messageCount: 0, privacyAccepted: false, typed: false });
  const sendRef = useRef(() => {});
  stateRef.current = { messageCount: userMessageCount, privacyAccepted, typed };

  useEffect(() => {
    const send = (keepalive = false) => {
      fetch(`${API}/visits/heartbeat`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        keepalive,
        body: JSON.stringify({
          visit_id: visitId,
          session_id: localStorage.getItem("cml_session_id"),
          active_seconds: activeRef.current,
          message_count: stateRef.current.messageCount,
          privacy_accepted: stateRef.current.privacyAccepted,
          typed: stateRef.current.typed,
        }),
      }).catch(() => {});
    };
    sendRef.current = send;

    const tick = setInterval(() => {
      if (document.visibilityState === "visible") activeRef.current += 5;
    }, 5000);
    const beat = setInterval(send, 20000);
    const onVisibility = () => { if (document.visibilityState === "hidden") send(true); };
    const onUnload = () => send(true);

    send();
    document.addEventListener("visibilitychange", onVisibility);
    window.addEventListener("beforeunload", onUnload);
    return () => {
      clearInterval(tick);
      clearInterval(beat);
      document.removeEventListener("visibilitychange", onVisibility);
      window.removeEventListener("beforeunload", onUnload);
    };
  }, [visitId]);

  useEffect(() => {
    if (userMessageCount > 0 || privacyAccepted || typed) sendRef.current();
  }, [userMessageCount, privacyAccepted, typed]);

  return visitId;
}
